import { useMatch } from 'react-router';

import DefaultLink from 'components/common/DefaultLink';
import Text from 'components/common/Text';
import CaretLeft from 'components/icons/navigation/CaretLeft';
import localStorage from 'helpers/localStorage';
import * as Routes from 'helpers/routes';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';
import TempoLogo from 'images/logo/tempo.svg';
import { SHOW_PROMO_BANNER_LOCAL_STORAGE } from 'lib/constants';

const NavBar = () => {
  const { isMobileOrTablet } = useScreenSizeConstants();

  const isMenuPage = useMatch({ path: Routes.PICK_MEALS_MENU_PATH });
  const isBillingPage = useMatch({ path: Routes.PICK_MEALS_BILLING_PATH });
  const isThankYouPage = useMatch({ path: Routes.PICK_MEALS_THANK_YOU_PATH });

  const logoDimensions = {
    width: isMobileOrTablet ? '70' : '100',
    height: isMobileOrTablet ? '36' : '34',
  };

  const handleLogoClick = () => {
    localStorage.delete(SHOW_PROMO_BANNER_LOCAL_STORAGE);
  };

  const renderLogo = () => (
    <div className="flex-initial pt-2.5">
      <a href="/" onClick={handleLogoClick}>
        <img
          src={TempoLogo}
          width={logoDimensions.width}
          height={logoDimensions.height}
          alt="Tempo logo"
        />
      </a>
    </div>
  );

  const renderBackButton = () => (
    <DefaultLink
      to={Routes.PICK_MEALS_MENU_PATH}
      className="flex items-center pl-5 pr-0 text-xs font-medium"
    >
      <CaretLeft className="h-4 w-4" />
      <Text
        htmlElement="span"
        className="sr-only uppercase bp1:not-sr-only"
        style={{ paddingLeft: '0.25rem' }}
      >
        Back
      </Text>
    </DefaultLink>
  );

  return (
    <div className="sticky inset-0 z-one mb-0 flex items-center border border-transparent bg-white-100 px-5 py-4 shadow bp1:static">
      {isMenuPage ? (
        <div className="flex items-center pl-2">{renderLogo()}</div>
      ) : isBillingPage ? (
        <>
          <div className="flex items-center">{renderBackButton()}</div>
          <div className="mr-5 flex flex-1 items-center justify-end">{renderLogo()}</div>
        </>
      ) : isThankYouPage ? (
        <div className="flex w-full items-center justify-end">
          <div className="mr-5">{renderLogo()}</div>
        </div>
      ) : null}
    </div>
  );
};

export default NavBar;
